import React, { useState } from 'react';
import {Header, getLangCookie} from './Header/Header';
import Footer from './Footer/Footer';
import P404 from './404/404'
import Home from './Home/Home';
import { Container } from 'react-bootstrap';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss'
import Information from './Information/Information';
import Register from './Register/Register';
import Nomination from './Nomination/Nomination';
import Partners from './Partners/Partners';
import Edition from './Editions/Edition';
import Pictures from './Editions/Pictures/Pictures';
import Rolemodels from './Rolemodels/Rolemodels';
import Sidebar from './Sidebar/Sidebar';

function App() {
  const [language, setLang] = useState(getLangCookie())
  return (
    <div className="App">
      <Header lang={language} setLang={setLang}></Header>
      <div className="row">
      <div className="col-md-1"></div>
      <Container className='container-xl mx-0 py-5 px-5 col-md-8' style={{ minHeight: '70vh' }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home lang={language}></Home>}></Route>
            <Route path='/information' element={<Information lang={language}></Information>}></Route>
            <Route path='/register' element={<Register lang={language}></Register>}></Route>
            <Route path='/nomination' element={<Nomination lang={language}></Nomination>}></Route>
            <Route path='/partners' element={<Partners lang={language}></Partners>}></Route>
            <Route path='/editions/:year' element={<Edition lang={language}></Edition>}></Route>
            <Route path='/pictures/:year' element={<Pictures lang={language}></Pictures>}></Route>
            <Route path='/rolemodels/:year' element={<Rolemodels lang={language}></Rolemodels>}></Route>
            <Route path="*" element={<P404 lang={language}></P404>}></Route>
          </Routes>
        </BrowserRouter>
      </Container>
      <Sidebar lang={language}></Sidebar>
      </div>
      <Footer lang={language}></Footer>
    </div>
  );
}

export default App;
